<template>
  <v-container
    id="jobClassTab"
    class="pa-0"
  >
    <base-resource-grid
      color="green"
      icon="mdi-account-supervisor"
      plural-name="Job Class"
      singular-name="Job Class"
      allow-expand
      :headers="gridHeaders"
      :resource="jobClassResource"
      :fetch-method="getJobClass"
      :custom-columns="customColumns"
      :actions="actions"
      :prepare-save="prepareSave"
      :disabled="disabled"
      @handleAction="handleAction"
      @item:updated="itemChanged"
      @item:added="itemChanged"
      @item:deleted="itemChanged"
    >
      <template
        v-slot:item.benefitEligible="{ item }"
      >
        {{ item.benefitEligible ? 'Yes' : 'No' }}
      </template>
      <template v-slot:editForm="bindings">
        <v-row>
          <v-col
            cols="12"
          >
            <v-text-field
              v-model="bindings.editedItem.jobClassName"
              :error-messages="bindings.formErrors.JobClassName"
              :disabled="disabled"
              label="Name"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
          >
            <v-text-field
              v-model="bindings.editedItem.jobClassDesc"
              :error-messages="bindings.formErrors.JobClassDesc"
              :disabled="disabled"
              label="Description"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
          >
            <base-resource-select
              label="Pay Group"
              item-text="payGroup"
              item-value="id"
              bind-text="payGroup"
              bind-value="oePayGroupId"
              :bind-item="bindings.editedItem"
              :error-messages="bindings.formErrors.OEPayGroupId"
              :fetch-method="getPayGroup"
              :disabled="disabled"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
          >
            <v-switch
              v-model="bindings.editedItem.benefitEligible"
              :error-messages="bindings.formErrors.BenefitEligible"
              :disabled="disabled"
              label="Benefit Eligible"
            />
          </v-col>
        </v-row>
      </template>
    </base-resource-grid>
    <base-history-dialog
      resource-endpoint="oeJobClassHistory/"
      id-field="oeJobClassId"
      title-field="jobClassName"
      color="green"
      :columns="historyColumns"
      :item="historyItem"
      @hide="historyItem = null"
    />
  </v-container>
</template>

<script>
  import TroodyApi from '@/services/troody/TroodyApi'

  export default {
    name: 'JobClassTab',

    props: {
      openEnrollment: {
        type: Object,
        default: null,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      formErrors: {
        type: Object,
        default: null,
      },
    },

    data: () => ({
      customColumns: [
        'benefitEligible',
      ],

      gridHeaders: [
        {
          text: 'Name',
          value: 'jobClassName',
        },
        {
          text: 'Pay Group',
          value: 'payGroup',
        },
        {
          text: 'Benefit Eligible',
          value: 'benefitEligible',
        },
      ],

      historyColumns: [
        {
          text: 'Name',
          value: 'jobClassName',
        },
        {
          text: 'Description',
          value: 'jobClassDesc',
        },
        {
          text: 'Pay Group',
          value: 'payGroup',
        },
        {
          text: 'Benefit Eligible',
          value: 'benefitEligible',
          dataType: 'boolean',
        },
      ],

      actions: [
        {
          color: 'info',
          icon: 'mdi-information-variant',
          action: 'history',
        },
      ],

      jobClassResource: new TroodyApi('oeJobClass/'),
      payGroupResource: new TroodyApi('oePayGroup/'),

      historyItem: null,
    }),

    methods: {
      getJobClass () {
        return this.jobClassResource.query({ openEnrollmentId: this.openEnrollment.id })
      },

      getPayGroup () {
        return this.payGroupResource.query({ openEnrollmentId: this.openEnrollment.id })
      },

      handleAction (action, data) {
        if (action === 'history') {
          this.historyItem = data
        }
      },

      itemChanged (data) {
        this.$emit('item:changed', data)
      },

      prepareSave (payload) {
        if (payload) {
          payload.openEnrollmentId = this.openEnrollment.id
        }
        return payload
      },
    },
  }
</script>
